import React, { useState, useEffect } from "react";
import "./style.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Button from "../CtaButton";

const PioneeringChange = ({ mainHeading, greenHeading, shortHeading, content, tabData, showIndustries, serviceTags }) => {
  const [activeTab, setActiveTab] = useState(0);
  const { t } = useTranslation("ksaHome");

  const pioneeringChange = t("pioneeringChange", {
    returnObjects: true,
  });

  const handleGtmClick = (industryName) => {
    // Push data to Google Tag Manager (GTM)
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "industry-btn-click",
      industry_title: industryName,
    });
  };

  useEffect(() => {
    tabData.forEach((tab) => {
      const img = new Image();
      img.src = `/images/pioner-imges/${tab.image}`;
    });
  }, [tabData]);

  return (
    <>
      <div className="poineering-change-box" id="pioner-change-box">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="poinering-change-box industries-main-heading-box">
                <h2 className="low-top-heading">{shortHeading}</h2>
                <h3>
                  {mainHeading} <span>{greenHeading}</span>
                </h3>
                <p className="description-text remove-description-text">{content}</p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="poinering-change-box">
                <ul className="poineering-list">
                  {tabData?.filter((tab) => {
                    // Check if showIndustries is provided & is a non-empty array
                    if (Array.isArray(showIndustries) && showIndustries.length > 0) {
                      // If so, filter the tabs based on the titles in showIndustries
                      return showIndustries.includes(tab.title);
                    }
                    // Otherwise, return true to show all tabs
                    return true;
                  })?.map((tab, index) => (
                    <li
                      id="poineering-industry-title"
                      key={index}
                      className={
                        activeTab === index ? "active-poineer-list" : ""
                      }
                      onClick={() => {
                        setActiveTab(index);
                        handleGtmClick(tab.title);
                      }}
                    >
                      <img src={`${tab.icon}`} alt="Industries Icon" />
                      <h5 dangerouslySetInnerHTML={{
                        __html: tab?.title,
                      }}></h5>
                    </li>
                  ))}
                </ul>

                {/* <Button text="Learn more" link="/contact-us" className="w-100" /> */}
              </div>
            </div>

            <div className="col-md-8">
              <div className="pioner-new-image-0 pioneer-chnage-box-0">
                <div
                  className="pioneering-main-img"
                // style={{
                //   background: `url('/images/pioner-imges/${tabData[activeTab].image}')`,
                // }}
                >
                  <div className="new-indsutries-section-image-box">
                    {/* <img src={`/images/pioner-imges/${tabData[activeTab].image}`} alt="" /> */}
                    <img
                      key={activeTab}
                      src={`/images/pioner-imges/${tabData[activeTab].image}`}
                      alt={tabData[activeTab].title}
                    />
                  </div>

                  <div className="pioner-text-box">
                    <h4 dangerouslySetInnerHTML={{
                      __html: tabData[activeTab].projectName || tabData[activeTab].title,
                    }}></h4>

                    <p className="description-text-white indsutry-section-width-control">
                      {tabData[activeTab].description}
                    </p>

                    {serviceTags && <div className="industries-tags-boxes">
                      {serviceTags?.map((item, index) => {
                        return <Link to={item?.link} target="_blank" className="text-decoration-none"><span className="industry-tag-box" key={index}>{item.title}</span></Link>
                      })}
                    </div>}

                    {/* <Link
                      id="industry_link_click"
                      to={`/industries/${tabData[activeTab]?.slug}`}
                      onClick={() =>
                        window.dataLayer.push({
                          event: "industry_link_click",
                          industry_title: tabData[activeTab].title,
                          industry_slug: `/industries/${tabData[activeTab]?.slug}`,
                        })
                      }
                    >
                      {pioneeringChange?.learnMoreLeft}{" "}
                      <span style={{ textTransform: "capitalize" }}>
                        {tabData[activeTab].slug}{" "}
                      </span>
                      {pioneeringChange?.learnMoreRight}{" "}
                      <i
                        className={`fa-solid ${document.dir === "rtl"
                          ? "fa-arrow-left"
                          : "fa-arrow-right"
                          }`}
                      ></i>
                    </Link> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PioneeringChange;
